import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '@/lib/api';

export function usePipelineSummary() {
  return useQuery({
    queryKey: ['dashboard', 'pipeline-summary'],
    queryFn: () => dashboardApi.getPipelineSummary(),
  });
}

export function useRecentActivity(take?: number) {
  return useQuery({
    queryKey: ['dashboard', 'recent-activity', take],
    queryFn: () => dashboardApi.getRecentActivity({ take }),
  });
}

export function useUpcomingCloses(take?: number) {
  return useQuery({
    queryKey: ['dashboard', 'upcoming-closes', take],
    queryFn: () => dashboardApi.getUpcomingCloses({ take }),
  });
}

export function useWinLossStats() {
  return useQuery({
    queryKey: ['dashboard', 'win-loss-stats'],
    queryFn: () => dashboardApi.getWinLossStats(),
  });
}

export function useFunnel() {
  return useQuery({
    queryKey: ['dashboard', 'funnel'],
    queryFn: () => dashboardApi.getFunnel(),
  });
}

export function useClosedRevenue() {
  return useQuery({
    queryKey: ['dashboard', 'closed-revenue'],
    queryFn: () => dashboardApi.getClosedRevenue(),
  });
}

export function useVisitorStats() {
  return useQuery({
    queryKey: ['dashboard', 'visitor-stats'],
    queryFn: () => dashboardApi.getVisitorStats(),
  });
}

export function usePipelineMetrics(pipelineId?: string) {
  return useQuery({
    queryKey: ['dashboard', 'pipeline-metrics', pipelineId],
    queryFn: () => dashboardApi.getPipelineMetrics(pipelineId),
  });
}

export function useRevenueForecast() {
  return useQuery({
    queryKey: ['dashboard', 'revenue-forecast'],
    queryFn: () => dashboardApi.getRevenueForecast(),
  });
}
